"use client";

import { createSystem, defaultConfig } from "@chakra-ui/react";
import { SYSTEM_COMMON } from "./common";

export const SYSTEM_ACOUNT_MDT52 = createSystem(defaultConfig, SYSTEM_COMMON, {
  theme: {
    tokens: {
      colors: {
        primary: {
          50: { value: "#F2F9F7" },
          100: { value: "#CCE5E1" },
          200: { value: "#A0CFC6" },
          300: { value: "#68B3A5" },
          400: { value: "#48A392" },
          500: { value: "#1C8C78" },
          600: { value: "#037762" },
          700: { value: "#02604F" },
          800: { value: "#025143" },
          900: { value: "#013B30" },
        },
        secondary: {
          50: { value: "#FDF5F8" },
          100: { value: "#F9D7E4" },
          200: { value: "#F4B4CD" },
          300: { value: "#ED86AE" },
          400: { value: "#E8699B" },
          500: { value: "#E13A7B" },
          600: { value: "#CC175D" },
          700: { value: "#A5134C" },
          800: { value: "#8C1040" },
          900: { value: "#670C2F" },
        },
      },
    },
  },
});
